import { filter_transform_config } from '/srv/web/wyvr/html/releases/58819/gen/client/odoscope/config/filter.js?1733898722583';
import { object_transform } from '/srv/web/wyvr/html/releases/58819/gen/client/odoscope/utils/object_transform.js?1733898722583';

export function get_odoscope_config(filter_config) {
    const odoscope_config = object_transform(filter_transform_config, filter_config);

    const load_configurables_on = {};

    // load simples per default
    odoscope_config.cr_oscProductType = 'variant';

    // get the category id from the stack
    const category_id = getStack('category_id');
    if (category_id) {
        odoscope_config.categoryId = category_id;
        const category_id_number = Number.parseInt(category_id, 10);
        // check which category should load the configurable/master products
        if (load_configurables_on?.categories?.includes(category_id_number)) {
            odoscope_config.cr_oscProductType = 'master';
        }
    }

    // get the brand attribute id from the stack
    const brand_value = getStack('brand_attribute');
    if (brand_value) {
        odoscope_config.cr_brand_value = brand_value;
        odoscope_config.categoryId = undefined;
    }

    for (const key in odoscope_config) {
        if (Array.isArray(odoscope_config[key])) {
            odoscope_config[key] = odoscope_config[key].join('|');
        }
        if (typeof odoscope_config[key] === 'string') {
            odoscope_config[key] = odoscope_config[key].replace(/,/g, '|').replace(/\|{2,}/g, '|');
        }
    }

    return odoscope_config;
}
